import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "use"];
import PropTypes from 'prop-types';
import cx from 'classnames';
import styled, { css } from 'styled-components';
import { FONT_FAMILIES, setFontSmoothing, toPx } from '../utils/Styles';
import NormalColors from '../core/NormalColors';
import { LORAX, NORMAN, OLAF, OZ, PANTERA, THUNDERDOME, KOALA, OBSIDIAN } from 'HubStyleTokens/colors';
import { badgeStylesMixin } from './internal';
import { jsx as _jsx } from "react/jsx-runtime";
const BADGE_COLORS = {
  pantera: PANTERA,
  koala: KOALA,
  beta: THUNDERDOME,
  default: LORAX,
  free: LORAX,
  new: OZ,
  none: null
};
const COUNT_BADGES = {
  count: null,
  dot: null
};
const BADGE_USES = Object.assign({}, NormalColors, BADGE_COLORS, COUNT_BADGES);
const DEFAULT_BADGE_USE = 'free';
const colorStylesMixin = props => {
  const backgroundColor = BADGE_USES[props.use] || BADGE_USES[DEFAULT_BADGE_USE];
  return css(["background-color:", ";color:", ";"], backgroundColor, backgroundColor === KOALA ? OBSIDIAN : OLAF);
};
const NOTIFICATION_BADGE_BORDER_WIDTH = '1px';
const NOTIFICATION_BADGE_DEFAULT_SIZE = '21px';
const NOTIFICATION_BADGE_FONT_SIZE = '11px';
const NOTIFICATION_BADGE_SMALL_SIZE = '10px';
const COMPUTED_LINE_HEIGHT = toPx(parseInt(NOTIFICATION_BADGE_DEFAULT_SIZE, 10) - parseInt(NOTIFICATION_BADGE_BORDER_WIDTH, 10) * 2);
const StyledBadge = styled.span.withConfig({
  displayName: "UIBadge__StyledBadge",
  componentId: "sc-19nzu4f-0"
})(["", ";", ";padding:0 8px;"], badgeStylesMixin, colorStylesMixin);
const countStyles = `
  ${FONT_FAMILIES.demibold()};
  font-size: ${NOTIFICATION_BADGE_FONT_SIZE};
  ${setFontSmoothing('antialiased')};
  border-radius: 500px;
  color: ${OLAF};
  line-height: ${COMPUTED_LINE_HEIGHT};
  min-height: ${NOTIFICATION_BADGE_DEFAULT_SIZE};
  min-width: ${NOTIFICATION_BADGE_DEFAULT_SIZE};
  padding: 0 4px;
`;
const dotStyles = `
  border-radius: 100%;
  height: ${NOTIFICATION_BADGE_SMALL_SIZE};
  text-indent: -1000rem;
  width: ${NOTIFICATION_BADGE_SMALL_SIZE};
`;
const CountBadge = styled.span.withConfig({
  displayName: "UIBadge__CountBadge",
  componentId: "sc-19nzu4f-1"
})(["background-color:", ";border:", " solid ", ";box-shadow:0 0 0 ", " ", ";display:inline-block;pointer-events:none;text-align:center;vertical-align:baseline;", ";", ";"], NORMAN, NOTIFICATION_BADGE_BORDER_WIDTH, OLAF, NOTIFICATION_BADGE_BORDER_WIDTH, OLAF, props => props.use === 'count' ? countStyles : null, props => props.use === 'dot' ? dotStyles : null);
const UIBadge = _ref => {
  let {
      children,
      className,
      use
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const RenderedBadge = !(use === 'count' || use === 'dot') ? StyledBadge : CountBadge;
  const computedClassName = cx(className, !(use === 'count' || use === 'dot') && 'private-badge', {
    'count': 'private-badge--count',
    'dot': 'private-badge--dot'
  }[use]);
  return /*#__PURE__*/_jsx(RenderedBadge, Object.assign({}, rest, {
    className: computedClassName,
    use: use,
    children: children
  }));
};
UIBadge.propTypes = {
  children: PropTypes.node.isRequired,
  use: PropTypes.oneOf(Object.keys(BADGE_USES))
};
UIBadge.defaultProps = {
  use: DEFAULT_BADGE_USE
};
UIBadge.displayName = 'UIBadge';
export default UIBadge;